const setTopicData = (data) => {
    return {
        type: "SET_TOPIC_DATA",
        payload: data
    }
}

export default {
    setTopicData,
}